export const getExpenseTypes = (state) => state.expense_types
export const getExpenseTypesMeta = (state) => state.meta_data
export const getAllExpenseTypes = (state) => state.all_expense_types


